<div class="payment-history-container" #container>
  <div class="container empty-state" *ngIf="!payments || payments?.length === 0">
    <span>
      <adp-label labelKey="Account_Billing_Payment_NoPaymentHistory"></adp-label>
    </span>
    <img src="../../../assets/images/dashboard-hero.svg" alt="" />
  </div>
  <div class="container" *ngIf="payments?.length > 0">
    <!-- Mobile View -->
    <div fxHide.gt-sm="true" class="mobile-container">
      <app-history-card *ngFor="let payment of pagedPaymentList; let i = index">
        <card-line-1>
          <div>{{payment.TransactionDateTime | date:'MM/dd/yyyy'}}</div>
          <div>{{formatStatus(payment.Status)}}</div>
        </card-line-1>
        <card-line-2>
          <div>Amount</div>
          <div>{{payment.Amount | currency}}</div>
        </card-line-2>
      </app-history-card>
      <mat-paginator appStylePaginator [showTotalPages]="3" [length]="payments.length" [pageSize]="pageSize"
        hidePageSize="false" (page)="pageEvent = onPageChange($event)">
      </mat-paginator>
    </div>
    <!-- Desktop View -->
    <div fxHide fxShow.gt-sm="true">
      <table mat-table [dataSource]="paymentsDataSource" class="mat-elevation-z0" matSort>

        <ng-container matColumnDef="TransactionDateTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <adp-label labelKey="Account_Payment_History_DateText"></adp-label>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.TransactionDateTime | date:'MM/dd/yyyy'}}</td>
        </ng-container>

        <ng-container matColumnDef="Amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <adp-label labelKey="Account_Payment_History_HeaderText"></adp-label>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.Amount | currency}}</td>
        </ng-container>

        <ng-container matColumnDef="PaymentMethodName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <adp-label labelKey="Account_Payment_History_PaymentMethod"></adp-label>
          </th>
          <td mat-cell *matCellDef="let element"> {{element.PaymentMethodName}}</td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <adp-label labelKey="Account_Payment_History_StatusText"></adp-label>
          </th>
          <td mat-cell *matCellDef="let element"> {{formatStatus(element.Status)}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>
      <mat-paginator #desktopPaginator appStylePaginator [showTotalPages]="3" [length]="payments?.length"
        [pageSize]="pageSize" hidePageSize="false">
      </mat-paginator>
    </div>
  </div>
</div>